/**
 * @format
 */
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/index";

import {
   ItemCategoryResponse,
   ItemTypeResponse,
   LocationResponse,
   LocationTypeResponse,
   StatesResponse,
} from "./trackable-item.types";

@Injectable()
export class TrackableItemsService {
   constructor(private httpClient: HttpClient) {}

   getItemCategory(userId: number): Observable<ItemCategoryResponse> {
      const url = Boolean(userId)
         ? `/servlets/trackableitem/itemCategory/?userid=${userId}`
         : "/servlets/trackableitem/";

      return this.httpClient.get<ItemCategoryResponse>(url, { observe: "body" });
   }

   getItemTypes(userId: number): Observable<ItemTypeResponse> {
      const url = Boolean(userId) ? `/servlets/trackableitem/itemType/?userid=${userId}` : "/servlets/itemType/";

      return this.httpClient.get<ItemTypeResponse>(url, { observe: "body" });
   }

   getStates(userId: number): Observable<StatesResponse> {
      const url = Boolean(userId) ? `/servlets/trackableitem/states/?userid=${userId}` : "/servlets/states/";

      return this.httpClient.get<StatesResponse>(url, { observe: "body" });
   }

   getLocations(userId: number): Observable<LocationResponse> {
      const url = Boolean(userId) ? `/servlets/trackableitem/location/?userid=${userId}` : "/servlets/location/";

      return this.httpClient.get<LocationResponse>(url, { observe: "body" });
   }

   getLocationTypes(userId: number): Observable<LocationTypeResponse> {
      const url = Boolean(userId)
         ? `/servlets/trackableitem/locationType/?userid=${userId}`
         : "/servlets/locationType/";

      return this.httpClient.get<LocationTypeResponse>(url, { observe: "body" });
   }
}
